import React, { Component } from 'react';

import {
  Row,
  Col,
  FormGroup,
  Input,
  Label
} from 'reactstrap';

import Form from '../../../shared/components/Form';
import Button from '../../../shared/components/Button';

import { divideArrayIntoNGroups } from '../../../shared/utils';

class CampaignPublisherForm extends Component {
  handleSubmit(data){
    this.props.onSubmit({publisherIds:Object.keys(data.publishers || {})});
  }

  render(){
    return (
      <div>
        <Form onSubmit={(data) => this.handleSubmit(data)}>
          <Row>
            {divideArrayIntoNGroups(this.props.publishers,2).map((group,i) => (
              <Col md='6' key={i}>
                {group.map((publisher) => (
                  <FormGroup check key={publisher.id}>
                    <Label check>
                      <Input
                        type='checkbox'
                        name={`publishers[${publisher.id}]`}
                        defaultChecked={this.props.selectedPublisherIds.indexOf(publisher.id) >= 0}
                      />
                      &nbsp;&nbsp;{publisher.name === 'Dabbl' ? 'Downtime Dollars' : publisher.name}
                    </Label>
                  </FormGroup>
                ))}
              </Col>
            ))}
          </Row>
          <br />
          <Button isSubmit>Save</Button>
        </Form>
      </div>
    )
  }
}

export default CampaignPublisherForm;



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignReview/components/CampaignPublisherForm.js